import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// passed as rest props to radialGradient

export default function RadialGradient(_ref) {
  let {
    children,
    id,
    from,
    to,
    fromOffset = '0%',
    fromOpacity = 1,
    toOffset = '100%',
    toOpacity = 1,
    rotate,
    transform,
    ...restProps
  } = _ref;
  return /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsxs("radialGradient", {
      id: id,
      gradientTransform: rotate ? `rotate(${rotate})` : transform,
      ...restProps,
      children: [!!children && children, !children && /*#__PURE__*/_jsx("stop", {
        offset: fromOffset,
        stopColor: from,
        stopOpacity: fromOpacity
      }), !children && /*#__PURE__*/_jsx("stop", {
        offset: toOffset,
        stopColor: to,
        stopOpacity: toOpacity
      })]
    })
  });
}